import React from "react";
import { Box } from "@chakra-ui/react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";

const locations = [
  {
    title: "Bástya Idősotthon",
    address: "4450 Tiszalök, Hősök tere 7/a",
    position: [48.021333, 21.381342],
  },
  {
    title: "Forrás Idősotthon",
    address: "4450 Tiszalök, Kossuth utca 41.",
    position: [48.019404, 21.377614],
  },
  {
    title: "Nappali ellátás",
    address: "4450 Tiszalök, Damjanich utca 24.",
    position: [48.009568, 21.380210],
  },
];


function FitBounds({ points }) {
  const map = useMap();

  React.useEffect(() => {
    if (!points?.length) return;
    const bounds = points.map((p) => p.position);
    map.fitBounds(bounds, { padding: [30, 30] });
  }, [map, points]);

  return null;
}

export default function OpenStreetMapOption() {
  return (
    <Box w="100%" h={{ base: "360px", md: "560px" }} rounded="2xl" overflow="hidden" borderWidth="1px" borderColor="gray.200">
      <MapContainer
        style={{ width: "100%", height: "100%" }}
        center={locations[2].position}
        zoom={14}
        scrollWheelZoom={false}
      >

        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <FitBounds points={locations} />

        {locations.map((loc) => (
          <Marker key={loc.title} position={loc.position}>
            <Popup>
              <strong>{loc.title}</strong>
              <br />
              {loc.address}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </Box>
  );
}
